import {
  BankDetailsConsignadoRequest,
  IConsignadoProposalDetail,
  IConsignadoProposalsList,
  NotificationReportResponse,
} from "@/models/consignado/proposal.model";
import { axiosConsignadoInstance } from "../axiosInstance";
import { GetProposalsConsignadoDTO } from "./dto/proposal.dto";

export type GetProposalsParamsConsignado = {
  page: number;
  pageSize: number;
  proposalId?: string;
  name?: string;
  cpf?: string;
  sellerName?: string;
  releasedValue?: number;
  proposalDate?: string;
  disbursementDate?: string;
  statuses?: string;
  // statuses?: ProposalStatus[];
  sortBy?: string;
  sortDirection?: string;
  origin?: string;
  searchTerm?: string;
  startDate?: string | null;
  endDate?: string | null;
  corbanId?: number;
};

export const getConsignadoProposals = async (
  params: GetProposalsConsignadoDTO
): Promise<IConsignadoProposalsList> => {
  try {
    const response = await axiosConsignadoInstance.get(
      `/api-consignado-trabalhador/v1/proposta/lista`,
      {
        params: {
          ...params,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Erro ao obter Propostas:", error);
    throw error;
  }
};

export const aprovarPropostaConsignado = async (
  id: string
): Promise<IConsignadoProposalDetail> => {
  try {
    const response =
      await axiosConsignadoInstance.post<IConsignadoProposalDetail>(
        `/api-consignado-trabalhador/v1/proposta/${id}/aprovar-formalizacao`
      );
    return response.data;
  } catch (error) {
    console.error("Erro ao aprovar proposta:", error);
    throw error;
  }
};

export const getConsignadoProposalById = async (
  id: string
): Promise<IConsignadoProposalDetail | null> => {
  try {
    const response = await axiosConsignadoInstance.get(
      `/api-consignado-trabalhador/v1/proposta/${id}`
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar proposta de consignado:", error);
    throw error;
  }
};

export const updateProposalBankDetails = async (
  proposalId: string,
  body: BankDetailsConsignadoRequest
): Promise<any> => {
  try {
    const response = await axiosConsignadoInstance.patch(
      `/api-consignado-trabalhador/v1/proposta/${proposalId}/dados-bancarios`,
      body
    );

    return response.data;
  } catch (error) {
    console.error("Erro ao atualizar dados bancários da propostas:", error);
    throw error;
  }
};

export const updateProposalAnaliseBank = async (
  proposalId: string,
  data: string
): Promise<any> => {
  try {
    const response = await axiosConsignadoInstance.put(
      `/api-consignado-trabalhador/v1/proposta/${proposalId}/analise-banco`,
      { msg: data }
    );

    return response.data;
  } catch (error) {
    console.error("Erro ao atualizar dados bancários da propostas:", error);
    throw error;
  }
};

export const rejectProposalConsignado = async (id: string, isBlackListed = false): Promise<any> => {
  try {
    const response = await axiosConsignadoInstance.post(
      `api-consignado-trabalhador/v1/proposta/${id}/cancelar`,
      { isBlackListed }
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao cancelar proposta:", error);
    throw error;
  }
};

export const getReportProposalSendEmail = async (
  proposalId: string
): Promise<NotificationReportResponse | null> => {
  try {
    const response = await axiosConsignadoInstance.get(
      `api-consignado-trabalhador/v1/proposta/${proposalId}/relatorio-envio-email`
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao cancelar proposta:", error);
    throw error;
  }
};

export const resendProposalEmailEmployee = async (
  proposalId: string,
  email: string
): Promise<any> => {
  try {
    const response = await axiosConsignadoInstance.post(
      `api-consignado-trabalhador/v1/proposta/email-empregado-pago`,
      { proposalId: proposalId, email: email }
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao reenviar email:", error);
    throw error;
  }
};

export const resendProposalEmailEmployer = async (
  proposalId: string,
  email: string
): Promise<any> => {
  try {
    const response = await axiosConsignadoInstance.post(
      `api-consignado-trabalhador/v1/proposta/email-empregador-pago`,
      { proposalId: proposalId, email: email }
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao reenviar email:", error);
    throw error;
  }
};

export const resendProposalWhatsApp = async (
  proposalId: string,
  naturalPersonPhoneNumber: string
): Promise<any> => {
  try {
    const response = await axiosConsignadoInstance.post(
      `api-consignado-trabalhador/v1/proposta/enviar-mensagem-proposta-pago`,
      { proposalId: proposalId, naturalPersonPhoneNumber: naturalPersonPhoneNumber }
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao reenviar WhatsApp:", error);
    throw error;
  }
};

export const findAllProposalsAtPendingBankAnalysis = async (): Promise<{ count: number }> => {
  try {
    const response = await axiosConsignadoInstance.get(`api-consignado-trabalhador/v1/proposta/pendente-analise-bancaria/quantidade`);
    return response.data
  } catch (error) {
    console.error('Erro ao buscar a quantidade de propostas com o status AGUARDANDO_ANALISE_BANCO', error)
    throw error
  }
}

export const downloadConsigProposalExcel = async (
  params: GetProposalsConsignadoDTO
): Promise<Blob> => {
  try {
    const response = await axiosConsignadoInstance.get("/api-consignado-trabalhador/v1/proposta/excel", {
      params,
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    console.error("Erro ao baixar Excel de propostas:", error);
    throw error;
  }
};

